import { INewsDisplay } from "api/types/NewsEntity";
import { IQuery } from "components/organisms/Menus/QueryMenu/QueryMenu";
import { QueryBuilder } from "helpers/queryFunctions";

import { BackendUrl, handleApiGet, handleApiPost } from "../api";

/**
 * NEW filter function meant to search everything
 */

export function apiOmniSearch(query: IQuery) {
  const queryString = QueryBuilder(query, "query");
  const searchUrl = `${BackendUrl}/filter/data${queryString}`;
  return handleApiGet(searchUrl);
}
export function apiOmniSearchCount(query: IQuery) {
  const queryString = QueryBuilder(query, "query");
  const searchUrl = `${BackendUrl}/filter/total${queryString}`;
  return handleApiGet(searchUrl);
}
export function apiFilter(query: IQuery) {
  const queryString = QueryBuilder(query, "wide");
  const filterUrl = `${BackendUrl}/filter/data${queryString}`;
  return handleApiGet(filterUrl);
}
export function apiFilterCount(query: IQuery) {
  const queryString = QueryBuilder(query, "wide");
  const filterUrl = `${BackendUrl}/filter/total${queryString}`;
  return handleApiGet(filterUrl);
}
export function apiFilterSidebar(query: INewsDisplay) {
  const filterUrl = `${BackendUrl}/filter/sidebar`;
  return handleApiPost(filterUrl, query);
}
